import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IUnmatchedOrderRepository } from '@/coreInfrastructureModule/interfaces/IUnmatchedOrderRepository';
import { ExistingOrder } from '../domains/entities/UnmatchedOrderItem';
import { GetExistingOrdersAdapter } from '../adapters/getExistingOrdersAdapter';

/**
 * 突合先候補の既存発注を取得するユースケース
 */
export class GetExistingOrdersUseCase {
  private repository: IUnmatchedOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IUnmatchedOrderRepository) {
    this.repository = repository;
  }

  /**
   * 既存発注を取得する
   * @returns 既存発注リスト
   */
  public async execute(): Promise<INetworkResult<ExistingOrder[], IError>> {
    const networkResult = await this.repository.getExistingOrders();
    switch (networkResult.status.type) {
      case 'success': {
        const items = GetExistingOrdersAdapter.adapt(networkResult.status.data.result.existingOrders);
        return { status: { type: 'success', data: items } };
      }
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
